import { CustomBranding, RequestParams } from '@commutifi-fe/interfaces';
import { EnterpriseProps } from '@commutifi/models/Enterprises';
import { apiCall, dashboardApiServer } from '../../index';
import endpoints from './endpoints';
const apiDashboardServer = apiCall(dashboardApiServer);
interface SubdomainData {
  data: {
    customBranding?: CustomBranding;
    enterprise?: EnterpriseProps;
  };
}
export const fetchSubdomainData = (subdomain: string, queryParams: RequestParams = {}): Promise<SubdomainData> => apiDashboardServer(endpoints.GET.SubdomainData.route(subdomain), {
  method: 'get',
  params: queryParams,
  // A 401 here is a domain answer (older dashboards rewrote "nothing resolved for this
  // subdomain" to 401), not an auth failure. The flag keeps the interceptor's
  // refresh→retry→forceLocalLogout chain away from it, which would otherwise tear down a
  // freshly-hydrated SSO session; useSubdomain maps the 401 to "nothing resolved" instead.
  skipAuthRefresh: true
});